import script from "./UserView.vue?vue&type=script&setup=true&lang=js"
export * from "./UserView.vue?vue&type=script&setup=true&lang=js"

import "./UserView.vue?vue&type=style&index=0&id=48576536&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-48576536"]])

export default __exports__